module.exports = __webpack_public_path__ + "img/u3882.24ba04d3.svg";